<div class="time-slot-booking">
    <!-- Debug alerts -->
    <div *ngIf="!product" class="alert alert-warning">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'no_product_data' | translate }}
        </div>
    </div>
    
    <div *ngIf="product && !product.booking" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'no_booking_config' | translate }}
        </div>
    </div>
    
    <div *ngIf="product?.booking && !product.booking.forBooking" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'booking_not_enabled' | translate }}
        </div>
    </div>
    
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType !== 'timeSlots'" class="alert alert-info">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'not_time_slot_booking' | translate }}
        </div>
    </div>

    <!-- Out of Stock Warning -->
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType === 'timeSlots' && !hasProductQuantity" class="alert alert-danger">
        <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
        </div>
        <div class="alert-content">
            {{ 'out_of_stock' | translate }}
        </div>
    </div>

    <!-- Main booking content -->
    <div *ngIf="product?.booking?.forBooking && product?.booking?.bookingType === 'timeSlots' && hasProductQuantity">
        
        <!-- Booking Info Header -->
        <div class="booking-info-header" *ngIf="getConstraintsText()">
            <div class="info-content">
                <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12,6 12,12 16,14"/>
                    </svg>
                </div>
                <div class="info-text">
                    {{ getConstraintsText() }}
                </div>
            </div>
        </div>

        <form [formGroup]="bookingForm" (ngSubmit)="createBooking()" class="booking-form">
            <div class="booking-layout">
                
                <!-- Left side: Date Selection -->
                <div class="date-section">
                    <div class="section-header">
                        <h4 class="section-title">{{ 'select_date' | translate }}</h4>
                        <div class="date-legend">
                            <div class="legend-item">
                                <span class="legend-dot available"></span>
                                <span class="legend-text">{{ 'available' | translate }}</span>
                            </div>
                            <div class="legend-item">
                                <span class="legend-dot selected"></span>
                                <span class="legend-text">{{ 'selected' | translate }}</span>
                            </div>
                            <div class="legend-item">
                                <span class="legend-dot unavailable"></span>
                                <span class="legend-text">{{ 'unavailable' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Calendar Navigation -->
                    <div class="calendar-navigation">
                        <button type="button" 
                                class="nav-button" 
                                [disabled]="currentMonthIndex === 0"
                                (click)="previousMonth()">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M15 18l-6-6 6-6"/>
                            </svg>
                        </button>
                        
                        <h3 class="month-title">{{ getCurrentMonth()?.monthName || '' }}</h3>
                        
                        <button type="button" 
                                class="nav-button" 
                                [disabled]="currentMonthIndex === calendarMonths.length - 1"
                                (click)="nextMonth()">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M9 18l6-6-6-6"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Calendar Grid -->
                    <div class="calendar-grid" *ngIf="getCurrentMonth()">
                        <!-- Weekday Headers -->
                        <div class="weekday-header">
                            <div class="weekday" *ngFor="let day of getTranslatedWeekDays()">{{ day }}</div>
                        </div>

                        <!-- Calendar Days -->
                        <div class="calendar-days">
                            <div *ngFor="let day of getCurrentMonth().days" 
                                 class="calendar-day"
                                 [class.available]="day.isAvailable && day.isCurrentMonth"
                                 [class.selected]="day.isSelected"
                                 [class.unavailable]="day.isUnavailable && day.isCurrentMonth"
                                 [class.other-month]="!day.isCurrentMonth"
                                 [class.today]="day.isToday"
                                 [class.has-slots]="day.hasSlots"
                                 [attr.title]="day.hasSlots ? ('has_time_slots' | translate) : ''"
                                 (click)="onDateSelected(day)">
                                
                                <span class="day-number">{{ day.day }}</span>
                                
                                <!-- Today indicator -->
                                <div *ngIf="day.isToday && !day.isSelected" class="today-dot"></div>
                                
                                <!-- Slots indicator -->
                                <div *ngIf="day.hasSlots && day.isAvailable && !day.isSelected" class="slots-indicator">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <circle cx="12" cy="12" r="10"/>
                                        <polyline points="12,6 12,12 16,14"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Selected Date Display -->
                    <div *ngIf="selectedDate" class="selected-date-display">
                        <div class="selected-date-label">{{ 'selected_date' | translate }}:</div>
                        <div class="selected-date-value">{{ getFormattedSelectedDate() }}</div>
                    </div>
                </div>

                <!-- Right side: Time Slots and Summary -->
                <div class="slots-section">
                    
                    <!-- Quantity Selector -->
                    <div class="quantity-section">
                        <div class="section-header">
                            <h4 class="section-title">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                                    <line x1="8" y1="21" x2="16" y2="21"/>
                                    <line x1="12" y1="17" x2="12" y2="21"/>
                                </svg>
                                {{ 'quantity' | translate }}
                            </h4>
                        </div>
                        <div class="quantity-control">
                            <app-input-number-new 
                                appClick 
                                layout="input-5" 
                                aria-label="Quantity"
                                class="product__quantity-availability amount quote-qty" 
                                [min]="product.quantity?.min || 1"
                                [max]="product.quantity?.max || 99" 
                                [step]="product.quantity?.step || 1"
                                [formControl]="quantityControl">
                            </app-input-number-new>
                            
                        </div>
                    </div>

                    <!-- Time Slots Selection -->
                    <div class="time-slots-container">
                        <div class="section-header">
                            <h4 class="section-title">{{ 'available_time_slots' | translate }}</h4>
                        </div>

                        <!-- Loading State -->
                        <div *ngIf="loading" class="loading-state">
                            <div class="loading-spinner">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M21 12a9 9 0 11-6.219-8.56"/>
                                </svg>
                            </div>
                            <span>{{ 'loading_time_slots' | translate }}</span>
                        </div>

                        <!-- No Date Selected -->
                        <div *ngIf="!selectedDate && !loading" class="no-date-selected">
                            <div class="empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                    <line x1="16" y1="2" x2="16" y2="6"/>
                                    <line x1="8" y1="2" x2="8" y2="6"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                            </div>
                            <p>{{ 'select_date_to_view_slots' | translate }}</p>
                        </div>

                        <!-- No Slots Available -->
                        <div *ngIf="selectedDate && !loading && availableSlots.length === 0" class="no-slots-available">
                            <div class="empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="15" y1="9" x2="9" y2="15"/>
                                    <line x1="9" y1="9" x2="15" y2="15"/>
                                </svg>
                            </div>
                            <p>{{ 'no_slots_available_for_date' | translate }}</p>
                        </div>

                        <!-- Available Time Slots - Update to show quantity information -->
                        <div *ngIf="!loading && availableSlots.length > 0" class="slots-grid">
                            <div *ngFor="let slot of availableSlots" 
                                 class="time-slot"
                                 [class.available]="slot.isAvailable"
                                 [class.selected]="slot.isSelected"
                                 [class.unavailable]="!slot.isAvailable">
                                
                                <div class="slot-time">
                                    <div class="time-range">
                                        {{ formatTime(slot.startTime) }} - {{ formatTime(slot.endTime) }}
                                    </div>
                                    <div class="slot-duration">
                                        {{ getDurationDisplayText(slot.duration) }}
                                    </div>
                                </div>

                                @if(!isQuotable){
                                    <div class="slot-details">
                                        <div class="slot-price">
                                            {{ slot.price | currencyConvert : product.companyData.currencyMeta.code }}
                                        </div>
                                        <div class="slot-quantity" *ngIf="selectedQuantity > 1">
                                            × {{ selectedQuantity }} = {{ (slot.price * selectedQuantity) | currencyConvert : product.companyData.currencyMeta.code }}
                                        </div>
                                        <div class="slot-availability" *ngIf="productQuantity > 1">
                                           
                                        </div>
                                    </div>
                                }

                                <!-- Simplified Slot Actions -->
                                <div class="slot-actions">
                                    <div *ngIf="!slot.isSelected && slot.isAvailable" class="add-slot">
                                        <button type="button" 
                                                class="btn-add-slot"
                                                [disabled]="!canAddMoreSlots() || !canSlotAccommodateQuantity(slot)"
                                                (click)="onSlotSelected(slot)"
                                                [title]="!canAddMoreSlots() ? ('max_slots_reached' | translate: { max: maxSlotsPerBooking }) : 
                                                        !canSlotAccommodateQuantity(slot) ? ('insufficient_quantity_slot' | translate) : 
                                                        ('add_slot' | translate)">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <line x1="12" y1="5" x2="12" y2="19"/>
                                                <line x1="5" y1="12" x2="19" y2="12"/>
                                            </svg>
                                            {{ 'book_slot' | translate }}
                                        </button>
                                    </div>

                                    <div *ngIf="slot.isSelected" class="selected-slot-info">
                                        <div class="selected-indicator">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M20 6L9 17l-5-5"/>
                                            </svg>
                                            {{ 'selected' | translate }}
                                            <span *ngIf="selectedQuantity > 1" class="selected-quantity">× {{ selectedQuantity }}</span>
                                        </div>

                                        <button type="button" 
                                                class="btn-remove-slot"
                                                (click)="removeSelectedSlot(slot.id)"
                                                [title]="'remove_slot' | translate">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <line x1="18" y1="6" x2="6" y2="18"/>
                                                <line x1="6" y1="6" x2="18" y2="18"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Selected Slots Summary - Update to show quantity -->
                    <div *ngIf="selectedSlots.length > 0" class="selected-slots-summary">
                        <div class="summary-header">
                            <h4>{{ 'selected_time_slots' | translate }}
                                <span class="quantity-indicator" *ngIf="selectedQuantity > 1">
                                    × {{ selectedQuantity }}
                                </span>
                            </h4>
                            <button type="button" 
                                    class="btn-clear-all"
                                    (click)="clearSelectedSlots()"
                                    [title]="'clear_all_slots' | translate">
                                {{ 'clear_all' | translate }}
                            </button>
                        </div>

                        <div class="selected-slots-list">
                            <div *ngFor="let selectedSlot of selectedSlots; trackBy: trackBySlotId" class="selected-slot-item">
                                <div class="slot-info">
                                    <div class="slot-time">
                                        {{ formatTime(selectedSlot.startTime) }} - {{ formatTime(selectedSlot.endTime) }}
                                    </div>
                                    <div class="slot-quantity" *ngIf="selectedQuantity > 1">
                                        {{ 'quantity' | translate }}: {{ selectedQuantity }}
                                    </div>
                                </div>
                                @if(!isQuotable){
                                    <div class="slot-price">
                                        <span *ngIf="selectedQuantity === 1">{{ selectedSlot.price | currencyConvert : product.companyData.currencyMeta.code }}</span>
                                        <span *ngIf="selectedQuantity > 1">
                                            {{ selectedSlot.price | currencyConvert : product.companyData.currencyMeta.code }} × {{ selectedQuantity }} = 
                                            {{ (selectedSlot.price * selectedQuantity) | currencyConvert : product.companyData.currencyMeta.code }}
                                        </span>
                                    </div>
                                }
                                
                                <button type="button" 
                                        class="btn-remove-slot"
                                        (click)="removeSelectedSlot(selectedSlot.slotId)"
                                        [title]="'remove_slot' | translate">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <line x1="18" y1="6" x2="6" y2="18"/>
                                        <line x1="6" y1="6" x2="18" y2="18"/>
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Updated Pricing Summary -->
                        <div class="pricing-summary">
                            <div class="price-line">
                                <span class="price-label">{{ 'total_slots' | translate }}:</span>
                                <span class="price-value">{{ totalSlots }}</span>
                            </div>
                            <div class="price-line" *ngIf="selectedQuantity > 1">
                                <span class="price-label">{{ 'quantity_per_slot' | translate }}:</span>
                                <span class="price-value">{{ selectedQuantity }}</span>
                            </div>
                            <div class="price-line" *ngIf="selectedQuantity > 1">
                                <span class="price-label">{{ 'total_items' | translate }}:</span>
                                <span class="price-value">{{ totalSlots * selectedQuantity }}</span>
                            </div>
                            @if(!isQuotable){
                                <div class="price-line total">
                                    <span class="price-label">{{ 'total_price' | translate }}:</span>
                                    <span class="price-value total-price">{{ totalPrice | currencyConvert : product.companyData.currencyMeta.code }}</span>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Booking Form -->
                    <!-- <div *ngIf="selectedSlots.length > 0" class="booking-details-form">
                        <h4>{{ 'booking_details' | translate }}</h4>
                        
                        <div class="form-group">
                            <label for="specialRequests">{{ 'special_requests' | translate }}</label>
                            <textarea id="specialRequests"
                                      formControlName="specialRequests"
                                      class="form-control"
                                      rows="3"
                                      [placeholder]="'special_requests_placeholder' | translate"></textarea>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="customerName">{{ 'customer_name' | translate }}</label>
                                <input type="text"
                                       id="customerName"
                                       formControlName="customerName"
                                       class="form-control"
                                       [placeholder]="'customer_name_placeholder' | translate">
                            </div>

                            <div class="form-group">
                                <label for="customerEmail">{{ 'customer_email' | translate }}</label>
                                <input type="email"
                                       id="customerEmail"
                                       formControlName="customerEmail"
                                       class="form-control"
                                       [placeholder]="'customer_email_placeholder' | translate">
                                <div *ngIf="bookingForm.get('customerEmail')?.invalid && bookingForm.get('customerEmail')?.touched" class="field-error">
                                    {{ 'invalid_email_format' | translate }}
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- Submit Button -->
                    <div *ngIf="selectedSlots.length > 0" class="booking-actions">
                        <button type="submit"
                                class="btn-create-booking"
                                [disabled]="!bookingForm.valid || loading || selectedSlots.length === 0"
                                [class.loading]="loading">
                            <div *ngIf="loading" class="loading-spinner">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M21 12a9 9 0 11-6.219-8.56"/>
                                </svg>
                            </div>

                            <!-- Cart icon for non-quotation products -->
                            <svg *ngIf="!loading && !isQuotable" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="9" cy="21" r="1"/>
                                <circle cx="20" cy="21" r="1"/>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                            </svg>

                            <!-- Check icon for quotation products -->
                            <svg *ngIf="!loading && isQuotable" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M9 11l3 3 8-8"/>
                            </svg>

                            <!-- Button text -->
                            <span *ngIf="!loading && !isQuotable">{{ 'add_to_cart' | translate }}</span>
                            <span *ngIf="!loading && isQuotable">{{ 'review_quote_request' | translate }}</span>
                            <span *ngIf="loading && !isQuotable">{{ 'adding_to_cart' | translate }}</span>
                            <span *ngIf="loading && isQuotable">{{ 'requesting_quote' | translate }}</span>
                        </button>

                        <!-- Buy Now button: visible only when Add to Cart is visible and for non-quotation bookings -->
                        <button type="button"
                                class="btn-create-booking ms-2"
                                *ngIf="selectedSlots.length > 0 && !isQuotable"
                                [disabled]="!bookingForm.valid || loading || selectedSlots.length === 0"
                                (click)="buyNow()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M3 3h18v4H3z"></path>
                                <path d="M6 14l3 3 9-9"></path>
                            </svg>
                            {{ 'buyNow' | translate }}
                        </button>

                       
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Quotation Request Modal -->
<div *ngIf="showQuotationForm" class="quotation-modal-overlay" (click)="closeQuotationForm()">
    <div class="quotation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">{{ 'request_quote' | translate }}</h3>
            <button type="button" class="modal-close" (click)="closeQuotationForm()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <!-- Booking Summary -->
            <div class="booking-summary">
                <h4>{{ 'booking_summary' | translate }}</h4>
                <div class="summary-grid">
                    <div class="summary-row">
                        <span class="label">{{ 'product' | translate }}:</span>
                        <span class="value">{{ (product.name.en | translate) || product.name.en }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'date' | translate }}:</span>
                        <span class="value">{{ getFormattedSelectedDate() }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'time_slots' | translate }}:</span>
                        <span class="value">{{ totalSlots }} {{ 'slots' | translate }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'quantity_per_slot' | translate }}:</span>
                        <span class="value">{{ selectedQuantity }}</span>
                    </div>
                    <div class="summary-row">
                        <span class="label">{{ 'total_slot_items' | translate }}:</span>
                        <span class="value">{{ totalSlots * selectedQuantity }}</span>
                    </div>
                </div>
                
                <!-- Selected slots list -->
                <div class="selected-slots-preview">
                    <div class="slots-list">
                        <div *ngFor="let slot of selectedSlots; let i = index" class="slot-preview">
                            <span class="slot-number">{{i + 1}}</span>
                            <span class="slot-time">{{ formatTime(slot.startTime) }} - {{ formatTime(slot.endTime) }}</span>
                            <span class="slot-quantity" *ngIf="selectedQuantity > 1">× {{ selectedQuantity }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Quote Request Form -->
            <div class="quote-form">
                <form [formGroup]="quotationForm" (ngSubmit)="submitQuotationRequest()">
                    <div class="form-field">
                        <label>{{ 'additional_requirements' | translate }}</label>
                        <textarea 
                            formControlName="description"
                            rows="4"
                            [placeholder]="'describe_special_requests' | translate"></textarea>
                    </div>

                    <div class="form-actions">
                        <button type="button" class="btn-cancel" (click)="closeQuotationForm()">
                            {{ 'cancel' | translate }}
                        </button>
                        <button type="submit" class="btn-submit" [disabled]="loading">
                            <span *ngIf="loading" class="spinner"></span>
                            {{ 'send_request' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
